import { render } from "./Blacklist.vue?vue&type=template&id=35ed9539&scoped=true"
import script from "./Blacklist.vue?vue&type=script&lang=js"
export * from "./Blacklist.vue?vue&type=script&lang=js"

import "./Blacklist.vue?vue&type=style&index=0&id=35ed9539&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ed9539"]])

export default __exports__